import ArgonTypography from 'components/ArgonTypography'
import DashboardLayout from 'examples/LayoutContainers/DashboardLayout'
import DashboardNavbar from 'examples/Navbars/DashboardNavbar'
import React from 'react'

import ArgonBox from "components/ArgonBox";


import Card from "@mui/material/Card";

// Argon Dashboard 2 MUI components


// Argon Dashboard 2 MUI examples
import Footer from "examples/Footer";

import {
  CardHeader,
  CardContent,
} from "@mui/material";

import { useState,useEffect } from "react";

import {Grid } from "@mui/material";
import ArgonInput from 'components/ArgonInput';
import ArgonButton from 'components/ArgonButton';
import Dropdown from 'components/CustomDropdown/Dropdown';


function AddTutor() {
  
  // Dropdown k liye
  const [Academic, setAcademic] = useState("");
  const [Board, setBoard] = useState("");
  const [Class, setClass] = useState("");
  const [Subject, setSubject] = useState("");

  return (

   <DashboardLayout>
      <DashboardNavbar />

      <ArgonBox py={3}>
        <ArgonBox mb={3}>
           <Card
      sx={{
        boxShadow: 6,
        borderRadius: 4,
        overflow: "hidden",
        background: "linear-gradient(180deg, #ffffff 0%, #f7f9fc 100%)",
        p: 1,
      }}
    >
      {/* Header */}
      <CardHeader
        title={
          <ArgonTypography
            variant="h5"
            fontWeight="bold"
            color="primary"
            textTransform="uppercase"
          >
            ✏️ Edit Video Questions
          </ArgonTypography>
        }
        subheader={
          <ArgonTypography variant="body2" color="text.secondary">
            Update academic details and edit your questions below
          </ArgonTypography>
        }
        sx={{
          borderBottom: "2px solid #f0f0f0",
          background: "#fafafa",
          py: 2,
        }}
      />

      {/* Body */}
      <CardContent>
        <form>
          <Grid container spacing={3}>
            {/* Academic Type */}
            <Grid item xs={12} md={6}>
              <ArgonTypography
                variant="subtitle2"
                fontWeight="medium"
                color="text"
                mb={1}
              >
                Academic Type
              </ArgonTypography>
              <Dropdown
                value={Academic}
                options={["Academic 1", "Academic 2", "Academic 3"]}
                onChange={(e) => setAcademic(e.target.value)}
                width="100%"
              />
            </Grid>

            {/* Board */}
            <Grid item xs={12} md={6}>
              <ArgonTypography
                variant="subtitle2"
                fontWeight="medium"
                color="text"
                mb={1}
              >
                Board
              </ArgonTypography>
              <Dropdown
                value={Board}
                options={["Board 1", "Board 2", "Board 3"]}
                onChange={(e) => setBoard(e.target.value)}
                width="100%"
              />
            </Grid>

            {/* Class */}
            <Grid item xs={12} md={6}>
              <ArgonTypography
                variant="subtitle2"
                fontWeight="medium"
                color="text"
                mb={1}
              >
                Class
              </ArgonTypography>
              <Dropdown
                value={Class}
                options={["Class 1", "Class 2", "Class 3"]}
                onChange={(e) => setClass(e.target.value)}
                width="100%"
              />
            </Grid>

            {/* Subject */}
            <Grid item xs={12} md={6}>
              <ArgonTypography
                variant="subtitle2"
                fontWeight="medium"
                color="text"
                mb={1}
              >
                Subject
              </ArgonTypography>
              <Dropdown
                value={Subject}
                options={["Subject 1", "Subject 2", "Subject 3"]}
                onChange={(e) => setSubject(e.target.value)}
                width="100%"
              />
            </Grid>

            {/* Question 1 */}
            <Grid item xs={12}>
              <ArgonTypography
                variant="subtitle2"
                fontWeight="medium"
                color="text"
                mb={1}
              >
                Question 1
              </ArgonTypography>
              <ArgonInput
                multiline
                rows={3}
                fullWidth
                placeholder="Enter Question"
                sx={{
                  backgroundColor: "#fff",
                  borderRadius: "12px",
                  "& .MuiInputBase-root": { borderRadius: "12px" },
                }}
              />
            </Grid>
          </Grid>

          {/* Footer buttons */}
          <ArgonBox
            display="flex"
            justifyContent="flex-end"
            gap={2}
            mt={4}
          >
            <ArgonButton
              variant="outlined"
              color="secondary"
              href="/admin/videoquestionsmanagement"
              sx={{
                borderRadius: "12px",
                px: 3,
              }}
            >
              Cancel
            </ArgonButton>
            <ArgonButton
              type="submit"
              variant="gradient"
              color="info"
              sx={{
                borderRadius: "12px",
                px: 4,
                fontWeight: "bold",
                boxShadow: "0px 4px 12px rgba(8,2,120,0.4)",
              }}
            >
              Save
            </ArgonButton>
          </ArgonBox>
        </form>
      </CardContent>
    </Card>
        </ArgonBox>
      </ArgonBox>
      <Footer />
    </DashboardLayout>


  )
}

export default AddTutor